import { Box as ChakraBox, BoxProps as ChakraBoxProps } from '@chakra-ui/react';

// @doc https://chakra-ui.com/docs/layout/box
export type BoxProps = ChakraBoxProps;
export const Box = ChakraBox;
